import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import { UserContextProvider } from './store/user-context'
import axios from 'axios'


// Add a request interceptor
axios.interceptors.request.use(request => {
  const token = localStorage.getItem('token');
  request.headers.Authorization = `Bearer ${token}`;
  return request;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <UserContextProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </UserContextProvider>
);